<script lang="ts">
	const { gadsId }: { gadsId?: string } = $props();
</script>

<svelte:head>
	{#if gadsId}
		<script async src={`https://www.googletagmanager.com/gtag/js?id=AW-${gadsId}`}></script>
		{@html `
		<script>
			window.dataLayer = window.dataLayer || [];
			function gtag() {
				dataLayer.push(arguments);
			}
			gtag('js', new Date());
			gtag('config', 'AW-${gadsId}', {'allow_enhanced_conversions': true})
		</script>
		`}
	{/if}
</svelte:head>
